import { Modal } from '@enterprise-ui/canvas-ui-react'
import { getOneDayInTheFuture } from '../services/helperFunctions'
import {
  getCurrentLocalDateString,
  getCurrentUTCDateString,
  convertDateToUTCDateString,
  convertDateToLocalDateString,
} from '../globalConfig/constants'

export const FutureDateTimezoneMismatchExplanationModal = (props) => {
  const today = new Date()
  let tomorrow = getOneDayInTheFuture(today)

  return (
    <Modal headingText="Timezone Mismatch" {...props}>
      <div className="hc-pa-normal">
        {new Date(getCurrentLocalDateString()) <
        new Date(getCurrentUTCDateString()) ? (
          <p>{`Dates are set in GMT. You are unable to select ${convertDateToLocalDateString(tomorrow)} because it is currently ${convertDateToUTCDateString(today)} in GMT, therefore ${convertDateToUTCDateString(tomorrow)} is the earliest future date you can select.`}</p>
        ) : (
          <p>{`Dates are set in GMT. ${convertDateToUTCDateString(tomorrow)} is the earliest future date you can set because it is currently ${convertDateToUTCDateString(today)} in GMT, even though it is ${getCurrentLocalDateString()} in your local timezone.`}</p>
        )}
      </div>
    </Modal>
  )
}
